<div class="add-credit-card">
  <div class="card-form">
    <div class="form-group">
      <div class="input-with-icon">
        <ustore-input
          [formControl]="cardNumberControl" 
          [placeholder]="'components.inputCreditCard.placeholder' | i18n"
          maxlength="19"
          [clearable]="false"
          (keydown)="onNumberKeydown($event)"
          (input)="onCardNumberInput($event)"
          (paste)="onCardNumberPaste($event)"
          (blur)="onCardNumberBlur()"
        ></ustore-input>
        
        <div class="card-type-indicator">
          <div 
            class="card-brand-icon"
            [class]="getCardTypeClass(cardNumberControl.value || '')"
            [title]="getCardBrandName(cardNumberControl.value || '')"
            role="img"
            [attr.aria-label]="getCardBrandName(cardNumberControl.value || '')">
          </div>
        </div>
      </div>

      <div *ngIf="cardNumberControl.errors?.['required'] && cardNumberControl.touched" class="field-error">
        {{ 'components.inputCreditCard.required' | i18n }}
      </div>
      <div *ngIf="cardNumberControl.errors?.['maxLengthExceeded'] && cardNumberControl.touched" class="field-error">
        {{ 'components.inputCreditCard.maxLength' | i18n }}
      </div>
      <div *ngIf="cardNumberControl.errors?.['invalidCardNumber'] && cardNumberControl.touched" class="field-error">
        {{ 'components.inputCreditCard.invalid' | i18n }}
      </div>
    </div>
  </div>
</div>